// コーチマークの位置調整
function returnCoachMark() {
  if (!$.cookie('is_return_coach_mark')) {
    $('.return-coach-mark').css('display', 'flex');
  }
  $('.return-question-text-link,.return-coach-mark-close,.return-question').on(
    'click',
    () => {
      $.cookie('is_return_coach_mark', true, { expires: 10 * 365, path: '/' });
      $('.return-coach-mark').css('display', 'none');
    },
  );
}

// コーチマーク、キービジュアル右「応援購入する」、PCスクロール時左側追従の「応援購入する」、「文章のTOPへ」クリック時に発火
// グローバル関数として window に登録する
window.onSupportPurchase = function onSupportPurchase() {
  $('html,body').animate({ scrollTop: $('#main').offset().top - 20 }, 200);
  return false;
};

$(() => {
  window.Geenie.Watched.set_cookie();
  returnCoachMark();
});
